var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-atc",class:{'o-atc--active':_vm.go},style:(_vm.posStyle),attrs:{"data-color":"primary"}},[_c('Placeholder',{attrs:{"is-atc":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }